class CartDrawer {
  static drawer = document.querySelector(".cart-drawer");
  static overlay = document.querySelector(".cart-overlay");
  static itemsContainer = document.querySelector(".cart-items");
  static total = document.querySelector(".cart-total-price");

  static init(){
    document.querySelector(".cart-close")?.addEventListener("click", ()=>this.close());
    
    this.overlay?.addEventListener("click", ()=>this.close());
    
    document.addEventListener("click", (e)=>{
    
      if(e.target.matches(".drawer-qty")){
        this.changeQty( e.target.dataset.key, e.target.dataset.qty);
      }

      if(e.target.matches(".remove-cart-item")){
        this.changeQty(e.target.dataset.key, 0);
      }
    });
  }

  static open(){
    this.drawer.classList.add("active");
    this.overlay.classList.add("active");
  }

  static close(){
    this.drawer.classList.remove("active");
    this.overlay.classList.remove("active");
  }

  static async render(){
    const cart = await fetch("/cart.js")
    .then(r=>r.json());

    if(cart.item_count === 0){
      this.itemsContainer.innerHTML = "<p>Cart Empty</p>";
      this.total.innerHTML = "₹0";
      return;
    }

    this.itemsContainer.innerHTML = cart.items.map(item=>`
      <div class="cart-item">
        <img src="${item.image}">
        <div class="cart-item-info">
          <h4>${item.product_title}</h4>
          <p>₹${item.final_price/100}</p>
          
          <div class="qty-wrap">
            <div class="qty-wrap-inner">
              <button class="drawer-qty qty-btn" data-key="${item.key}" data-qty="${item.quantity-1}">-</button>
              <span>${item.quantity}</span>
              <button class="drawer-qty qty-btn" data-key="${item.key}" data-qty="${item.quantity+1}">+</button>
            </div>
            
            <button class="remove-cart-item" data-key="${item.key}">Remove</button>
          </div>
        </div>
      </div>
    `).join("");

    this.total.innerHTML = `₹${(cart.total_price/100).toFixed(2)}`;
  }

  static async changeQty(key, quantity){
    await fetch("/cart/change.js", {
      method:"POST",
      headers:{
        "Content-Type":
        "application/json"
      },
      body:JSON.stringify({
        id:key,
        quantity
      })
    });

    this.render();
  }
}

document.addEventListener("DOMContentLoaded", ()=>{
  CartDrawer.init();
  CartDrawer.render();
  window.CartDrawer = CartDrawer;
});